import { Stack, Typography } from "@mui/material";
import clsx from "clsx";

// Helpers
import { number2ordinal } from "@Common/helpers/number";

const isOrdinal = (title: string): boolean => {
	const suffix = title.replace(/\d/g, "");
	const testOrdinal = /1.th|(^|[^1])(1st|2nd|3rd|[^1-3]th)/.test(title);
	return suffix.length === 2 && testOrdinal;
};

const getOrdinalLabel = (title: string) => {
	const suffix = title.replace(/\d/g, "");
	const numbers = title.replace(/[^\d]/g, "");

	return (
		<>
			{numbers}
			<sup>{suffix}</sup>
		</>
	);
};

const getFormattedTitle = (title: string, variant = "default"): string => {
	if (variant === "ordinal" && !isNaN(Number(title))) {
		return number2ordinal(title);
	}
	return title;
};

export default function DefaultVariant(props: Readonly<{ title?: string; selected?: boolean; variant?: string }>) {
	const { title = "", variant = "default", selected = false } = props;

	const formattedTitle = getFormattedTitle(title, variant);
	const label = isOrdinal(formattedTitle) ? getOrdinalLabel(formattedTitle) : title;

	if (variant === "ordinal" && !isOrdinal(formattedTitle)) {
		return null;
	}

	return (
		<Stack
			className={clsx({
				"border border-solid border-primary rounded-[6px] min-w-[30px]": true,
				"!border-white": selected,
			})}
			direction={"row"}
			alignItems={"center"}
			justifyContent={"center"}
		>
			<Typography
				className={clsx({
					"!font-sans !text-[12.5px] !px-1 w-full text-center": true,
					"!text-white": selected,
					"!text-primary": !selected,
				})}
				noWrap
			>
				{label}
			</Typography>
		</Stack>
	);
}
